import React, { useState } from 'react'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useKeyMetrics } from 'redux/hooks/KeyMetrics'
import { useIsMobile } from 'utils/hooks'
import { useTranslation } from 'language/translator'

import Button from 'components_new/atoms/Button'
import Link from 'components_new/atoms/Link'

import StatusBox from 'components_new/molecules/StatusBox'

import KeyMetricsHeader from 'components_new/organisms/KeyMetricsHeader'
import KeyMetricsTree from 'components_new/organisms/KeyMetricsTree'

import PageLayout from 'components_new/templates/PageLayout'

const KeyMetrics = () => {
  const { isAdmin } = useAccountSettings()
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const [keyMetrics] = useKeyMetrics()

  const [editMode, setEditMode] = useState<boolean>(false)

  return (
    <PageLayout
      content={{
        editMode: {
          active: editMode
        },
        size: 'large'
      }}
      footer={{
        mobile: {
          showNavigation: true
        }
      }}
      topbar={{
        actions:
          isAdmin && !isMobile ? (
            <Button
              onClick={() => setEditMode(!editMode)}
              variant={editMode ? 'contained' : 'text'}
            >
              {editMode ? t('global', 'done') : t('global', 'edit')}
            </Button>
          ) : null,
        breadcrumbs: [{ title: t('key_metrics', 'key_metrics') }]
      }}
      variant="feed"
    >
      <StatusBox
        severity="success"
        sx={{ mb: 2 }}
        title="Testperioden är avslutad"
      >
        Tack för att du har testat den här funktionen! Vi har utvärderat den
        tillsammans med våra kunder och tar nu med det bästa vi lärt oss in i
        vår nya produkt:{' '}
        <Link href={'https://homepal.se/product/analyses'} newTab={true}>
          Analyser
        </Link>
        . Den här sidan tas bort <b>fredag 23 oktober</b>. Använder du den
        mycket och vill motivera varför den bör finnas kvar? Hör av dig till
        kundansvarig.
      </StatusBox>

      <KeyMetricsHeader
        sx={{
          ...(editMode
            ? {
                cursor: 'not-allowed',
                opacity: 0.5,
                pointerEvents: 'none'
              }
            : null),
          mb: 2
        }}
      />
      <KeyMetricsTree editMode={editMode} keyMetrics={keyMetrics} />
    </PageLayout>
  )
}

export default KeyMetrics
